/**
 * Password policy enforced on the reset-password form (front-end UX check only —
 * NEVER a security boundary; the backend enforces the SAME rules server-side).
 *
 * Kept as a single editable constant so the policy lives in ONE place. It mirrors
 * the backend `ResetPasswordDto` (HOMCO-518): length 12–72 + at least one uppercase,
 * one lowercase, one digit and one special character (72 is the bcrypt byte limit).
 * If the backend policy changes, update the values below to match (they must stay in sync).
 */
export const PASSWORD_POLICY = {
  minLength: 12,
  maxLength: 72,
  requireUppercase: true,
  requireLowercase: true,
  requireDigit: true,
  requireSpecial: true,
} as const;

export type PasswordPolicy = typeof PASSWORD_POLICY;
